export const USER_UPLOADS_FOLDER_ID = 'ba0d04a8-a259-4254-9f29-54eb308e0ffd';

export const PROMOTER_ROLE_ID = '73743b36-550f-4e09-841e-0322ef1c3478';
